/* eslint-disable max-len */
import React from 'react';
import { css, cx } from '@emotion/css';

const SvgIcon = css`
    height: 14px;
    width: 14px;
`;

const cls1 = css`
  fill: currentColor;
`;

export const IconSort = () => (
  <svg className={cx(cls1, SvgIcon)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 11">
    <g id="Group_12" data-name="Group 12">
      <path id="Rectangle_11" data-name="Rectangle 11" className={cls1} d="M1.5.73h9a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-9a1,1,0,0,1-1-1h0A1,1,0,0,1,1.5.73Z" />
      <path id="Rectangle_12" data-name="Rectangle 12" className={cls1} d="M3.5,4.73h5a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-5a1,1,0,0,1-1-1h0A1,1,0,0,1,3.5,4.73Z" />
      <path id="Rectangle_13" data-name="Rectangle 13" className={cls1} d="M5,8.27H7a1,1,0,0,1,1,1H8a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1H4A1,1,0,0,1,5,8.27Z" />
    </g>
  </svg>
);
